// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__v1Axk","searchInput":"SearchBar_searchInput__fwoz1"};